import(/* webpackMode: "eager" */ "/app/app/[lng]/application/layout.tsx");
